import { useState, useEffect } from 'react';
import { beijingToday } from './datetime';

// 返回“北京时间的今天”（YYYY-MM-DD），过了 0 点会自动变成新的一天。
// 页面一直开着、或手机切回前台时也会立刻校正，用它当日期依赖的页面不会停在昨天。
export function useBeijingToday() {
  const [today, setToday] = useState(beijingToday);
  useEffect(() => {
    const check = () => setToday(prev => { const t = beijingToday(); return t === prev ? prev : t; });
    const timer = setInterval(check, 15000);
    document.addEventListener('visibilitychange', check);
    window.addEventListener('focus', check);
    return () => {
      clearInterval(timer);
      document.removeEventListener('visibilitychange', check);
      window.removeEventListener('focus', check);
    };
  }, []);
  return today;
}
